import type { AccTabItem } from 'accelerator-common/lib/AccTabList';
import { getApplicationSettings } from 'owa-application-settings';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import BuildingFilled from 'owa-fluent-icons-svg/lib/icons/BuildingFilled';
import BuildingRegular from 'owa-fluent-icons-svg/lib/icons/BuildingRegular';
import DataPieFilled from 'owa-fluent-icons-svg/lib/icons/DataPieFilled';
import DataPieRegular from 'owa-fluent-icons-svg/lib/icons/DataPieRegular';
import React from 'react';
import Dashboard from '../assets/Dashboard';
import DashboardFilled from '../assets/DashboardFilled';
import { ADMIN_ROOT, SPACE_ANALYTICS, SPACE_MANAGEMENT } from '../constants/adminRoutes';
import { useRoleContext, UserRoles } from '../context/RoleContext';
import {
    hybridspaceAdminDashboardLink as strings_hybridspaceAdminDashboardLink,
    hybridspaceAnalyticsLink as strings_hybridspaceAnalyticsLink,
    hybridspaceManagementLink as strings_hybridspaceManagementLink,
} from '../strings/useHybridspaceAdminLinks.locstring.json';

export interface useHybridspaceAdminLinksProps {
    isSpaceManagementEnabled: boolean;
    isSpaceAnalyticEnabled: boolean;
}
export default function useHybridspaceAdminLinks({
    isSpaceManagementEnabled,
    isSpaceAnalyticEnabled,
}: useHybridspaceAdminLinksProps): AccTabItem[] {
    const isDeprecatedSpaceManagementEnabled =
        !isSpaceManagementEnabled && getApplicationSettings('MsPlaces').spaceManagementTabEnabled;

    const { userRole } = useRoleContext();
    const roleSwitcherDisabled = isAccountFeatureEnabled(
        'msplaces-disableRoleSwitcher',
        getModuleContextMailboxInfo()
    );
    const shouldHideAdminLinks = !roleSwitcherDisabled && userRole !== UserRoles.Admin;

    return React.useMemo(
        () => [
            {
                id: 'AdminDashboard',
                key: `/${ADMIN_ROOT}`,
                icon: Dashboard,
                activeIcon: DashboardFilled,
                textResourceId: strings_hybridspaceAdminDashboardLink,
                ariaLabelResourceId: strings_hybridspaceAdminDashboardLink,
                hidden: true,
            },
            {
                id: 'SpaceManagement_Deprecated',
                key: `/${ADMIN_ROOT}/${SPACE_MANAGEMENT}`,
                icon: BuildingRegular,
                activeIcon: BuildingFilled,
                textResourceId: strings_hybridspaceManagementLink,
                ariaLabelResourceId: strings_hybridspaceManagementLink,
                hidden: !isDeprecatedSpaceManagementEnabled || shouldHideAdminLinks,
            },
            {
                id: 'SpaceManagement',
                key: `/${ADMIN_ROOT}/${SPACE_MANAGEMENT}`,
                icon: BuildingRegular,
                activeIcon: BuildingFilled,
                textResourceId: strings_hybridspaceManagementLink,
                ariaLabelResourceId: strings_hybridspaceManagementLink,
                hidden: !isSpaceManagementEnabled || shouldHideAdminLinks,
            },
            {
                id: 'SpaceAnalytics',
                key: `/${ADMIN_ROOT}/${SPACE_ANALYTICS}`,
                icon: DataPieRegular,
                activeIcon: DataPieFilled,
                textResourceId: strings_hybridspaceAnalyticsLink,
                ariaLabelResourceId: strings_hybridspaceAnalyticsLink,
                hidden: !isSpaceAnalyticEnabled || shouldHideAdminLinks,
            },
        ],
        [
            isDeprecatedSpaceManagementEnabled,
            shouldHideAdminLinks,
            isSpaceAnalyticEnabled,
            isSpaceManagementEnabled,
        ]
    );
}
